export default "/images/gjensidige-min.webp?c1092c95caa1c9a8a9c50d236c42f18b";